import React, { useState } from "react";
import Snackbar from "@mui/material/Snackbar";
import Button from "@mui/material/Button";
import Alert from "@mui/material/Alert";
import AlertTitle from "@mui/material/AlertTitle";
import CheckIcon from "@mui/icons-material/Check";

function CookieSnackbar() {
  const [open, setOpen] = useState(
    !Boolean(localStorage.getItem("isCookieAccepted"))
  );
  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
    localStorage.setItem("isCookieAccepted", "true");
  };
  const action = (
    <Button color="primary" size="small" onClick={handleClose}>
      <CheckIcon />
    </Button>
  );

  return (
    <React.Fragment>
      <Snackbar
        open={open}
        autoHideDuration={6000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert elevation={6} action={action} severity="info">
          <AlertTitle>This Site Uses Cookies</AlertTitle>
          By continuing to browse the site, you agree to our use of{" "}
          <strong>cookies</strong>.
        </Alert>
      </Snackbar>
    </React.Fragment>
  );
}

export default CookieSnackbar;
